import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { TimeSelectionCalendar } from './time-selection-calendar.model';

@Injectable()
export class TimeSelectionCalendarService {

  constructor(private http: HttpClient) { }


}
